import React, { useEffect, useState } from "react";
import { Loader } from "../component/loader";
import { NavBar } from "../component/NavBar";
import { Container } from "react-bootstrap";
import { Footer } from "../component/Footer";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet-async";
import Silverfort from "../component/Silverfort/Silverfort";

const SilverfortPage = () => {
  const [loading, setLoading] = useState(true);

  ReactGA.initialize("G-6WD5GM86HD");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <Helmet>
            <title>
              Silverfort - Techsa Services Pvt. Ltd.
            </title>
            <meta
              name="description"
              content=" "
            />
              <link href="/Silverfort" />
             <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Techsa Services Pvt. Ltd.",
            "url": "https://www.techsa.net/",
            "logo": "",
            "sameAs": "https://in.linkedin.com/company/techsa-services-pvt-ltd"
          }
        `}
      </script>
          </Helmet>
          <NavBar />
          <Container>
            <div className="solarwinds">
              <Silverfort />
            </div>
          </Container>
          <Footer />
        </div>
      )}
    </>
  );
};

export default SilverfortPage;
